import { useState, useEffect } from "react";
import { supabase } from "./supabase";
import Auth from "./Auth";
import NoteDisplay from "./NoteDisplay";


const API = "https://attune-production.up.railway.app";

const theme = {
  bg: "#F0F4F8",
  surface: "#FFFFFF",
  surfaceAlt: "#E8F4F0",
  border: "#D1E3DD",
  navy: "#1A2E3B",
  navyLight: "#2C4A5A",
  teal: "#0E9F7E",
  tealLight: "#13C49E",
  tealPale: "#E6F7F3",
  green: "#27AE60",
  greenPale: "#EAFAF1",
  blue: "#2980B9",
  bluePale: "#EBF5FB",
  textPrimary: "#1A2E3B",
  textSecondary: "#5A7A8A",
  textMuted: "#8FA8B4",
  white: "#FFFFFF",
  danger: "#E74C3C",
  dangerPale: "#FDEDEC",
};

export default function App() {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [view, setView] = useState("clients");
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [notes, setNotes] = useState([]);
  const [summary, setSummary] = useState("");
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);
  const [newName, setNewName] = useState("");
  const [newConcern, setNewConcern] = useState("");
  const [newDob, setNewDob] = useState("");
  const [addingClient, setAddingClient] = useState(false);
  const [expandedNote, setExpandedNote] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      setAuthLoading(false);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (user) fetchClients();
  }, [user]);

  const getToken = async () => {
    const { data: { session } } = await supabase.auth.getSession();
    return session?.access_token;
  };

  const fetchClients = async () => {
    const token = await getToken();
    const res = await fetch(`${API}/clients`, { headers: { Authorization: `Bearer ${token}` } });
    const data = await res.json();
    setClients(data);
  };

  const fetchNotes = async (clientId) => {
    const token = await getToken();
    const res = await fetch(`${API}/clients/${clientId}/notes`, { headers: { Authorization: `Bearer ${token}` } });
    const data = await res.json();
    setNotes(data);
  };

  const addClient = async () => {
    if (!newName.trim()) return;
    const token = await getToken();
    await fetch(`${API}/clients`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({ name: newName, date_of_birth: newDob, presenting_concern: newConcern }),
    });
    setNewName(""); setNewDob(""); setNewConcern("");
    setAddingClient(false);
    fetchClients();
  };

  const selectClient = (client) => {
    setSelectedClient(client);
    setNote(""); setSummary(""); setExpandedNote(null);
    fetchNotes(client.id);
    setView("notes");
  };

  const generateNote = async () => {
    if (!summary.trim()) return;
    setLoading(true); setNote("");
    try {
      const token = await getToken();
      const res = await fetch(`${API}/generate-note`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ summary, client_id: selectedClient.id }),
      });
      const data = await res.json();
      setNote(data.note);
      fetchNotes(selectedClient.id);
    } catch { setNote("Error connecting to server."); }
    setLoading(false);
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setClients([]); setSelectedClient(null); setView("clients");
  };

  if (authLoading) return (
    <div style={{ minHeight: "100vh", background: theme.bg, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ color: theme.teal, fontSize: 16, fontFamily: "Georgia, serif" }}>Loading...</div>
    </div>
  );

  if (!user) return <Auth onLogin={setUser} />;
document.head.insertAdjacentHTML("beforeend", `<style>@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }</style>`);
  return (
    <div style={{ minHeight: "100vh", background: theme.bg, fontFamily: "'Georgia', serif" }}>

      {/* Top Nav */}
      <div style={{ background: theme.navy, padding: "0 40px", display: "flex", alignItems: "center", justifyContent: "space-between", height: 64, boxShadow: "0 2px 12px rgba(0,0,0,0.15)" }}>
   <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <svg width="36" height="24" viewBox="0 0 36 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <style>{`@keyframes wave { 0% { stroke-dashoffset: 100; } 100% { stroke-dashoffset: 0; } }`}</style>
            <path
              d="M0 12 Q4 4 8 12 Q12 20 16 12 Q20 4 24 12 Q28 20 32 12 Q34 8 36 12"
              stroke="#0E9F7E"
              strokeWidth="2.5"
              fill="none"
              strokeLinecap="round"
              strokeDasharray="100"
              strokeDashoffset="100"
              style={{ animation: "wave 1.5s ease-in-out infinite alternate" }}
            />
          </svg>
          <span style={{ color: theme.white, fontSize: 20, fontWeight: 400, letterSpacing: 0.5 }}>attune</span>
          <span style={{ color: theme.teal, fontSize: 11, letterSpacing: 2, textTransform: "uppercase", marginLeft: 4 }}>Beta</span>
        </div>
Save with Command + S and tell me what you see!
        <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
          <span style={{ color: theme.textMuted, fontSize: 14 }}>{user.email}</span>
          <button onClick={handleLogout} style={{ background: "transparent", border: `1px solid rgba(255,255,255,0.2)`, borderRadius: 6, color: "rgba(255,255,255,0.7)", padding: "8px 16px", fontSize: 13, fontFamily: "Georgia, serif", cursor: "pointer" }}>
            Sign Out
          </button>
        </div>
      </div>

      <div style={{ maxWidth: 1000, margin: "0 auto", padding: "40px 24px" }}>

        {/* CLIENTS VIEW */}
        {view === "clients" && (
          <div>
            <div style={{ marginBottom: 32 }}>
              <h1 style={{ fontSize: 34, fontWeight: 400, color: theme.textPrimary, margin: "0 0 6px" }}>Client List</h1>
              <p style={{ color: theme.textSecondary, fontSize: 16, margin: 0 }}>{clients.length} active client{clients.length !== 1 ? "s" : ""}</p>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 24 }}>
              <button onClick={() => setAddingClient(!addingClient)} style={{ background: addingClient ? theme.surface : theme.teal, color: addingClient ? theme.textSecondary : theme.white, border: addingClient ? `1px solid ${theme.border}` : "none", borderRadius: 8, padding: "12px 28px", fontSize: 15, fontWeight: 600, fontFamily: "Georgia, serif", cursor: "pointer", boxShadow: addingClient ? "none" : "0 2px 8px rgba(14,159,126,0.3)" }}>
                {addingClient ? "Cancel" : "+ Add Client"}
              </button>
            </div>

            {addingClient && (
              <div style={{ background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "28px 32px", marginBottom: 28, boxShadow: "0 4px 20px rgba(0,0,0,0.06)" }}>
                <h3 style={{ margin: "0 0 24px", fontSize: 18, color: theme.textPrimary, fontWeight: 400 }}>New Client</h3>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>
                  <div>
                    <label style={{ fontSize: 12, letterSpacing: 2, color: theme.teal, textTransform: "uppercase", display: "block", marginBottom: 8, fontWeight: 600 }}>Full Name *</label>
                    <input value={newName} onChange={e => setNewName(e.target.value)} placeholder="Client full name"
                      style={{ width: "100%", background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 8, color: theme.textPrimary, fontSize: 15, padding: "12px 16px", fontFamily: "Georgia, serif", outline: "none", boxSizing: "border-box" }} />
                  </div>
                  <div>
                    <label style={{ fontSize: 12, letterSpacing: 2, color: theme.teal, textTransform: "uppercase", display: "block", marginBottom: 8, fontWeight: 600 }}>Date of Birth</label>
                    <input value={newDob} onChange={e => setNewDob(e.target.value)} placeholder="MM/DD/YYYY"
                      style={{ width: "100%", background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 8, color: theme.textPrimary, fontSize: 15, padding: "12px 16px", fontFamily: "Georgia, serif", outline: "none", boxSizing: "border-box" }} />
                  </div>
                </div>
                <div style={{ marginBottom: 24 }}>
                  <label style={{ fontSize: 12, letterSpacing: 2, color: theme.teal, textTransform: "uppercase", display: "block", marginBottom: 8, fontWeight: 600 }}>Presenting Concern</label>
                  <input value={newConcern} onChange={e => setNewConcern(e.target.value)} placeholder="e.g. Anxiety, depression, trauma, postpartum"
                    style={{ width: "100%", background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 8, color: theme.textPrimary, fontSize: 15, padding: "12px 16px", fontFamily: "Georgia, serif", outline: "none", boxSizing: "border-box" }} />
                </div>
                <button onClick={addClient} style={{ background: theme.teal, color: theme.white, border: "none", borderRadius: 8, padding: "13px 32px", fontSize: 15, fontWeight: 600, fontFamily: "Georgia, serif", cursor: "pointer", boxShadow: "0 2px 8px rgba(14,159,126,0.3)" }}>
                  Save Client
                </button>
              </div>
            )}

            {clients.length === 0 && !addingClient && (
              <div style={{ textAlign: "center", padding: "80px 0", color: theme.textMuted, fontSize: 16 }}>
                <div style={{ fontSize: 40, marginBottom: 16 }}>👤</div>
                No clients yet. Add your first client to get started.
              </div>
            )}

            <div style={{ display: "grid", gap: 12 }}>
              {clients.map(client => (
                <div key={client.id} onClick={() => selectClient(client)}
                  style={{ background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "20px 28px", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", boxShadow: "0 2px 8px rgba(0,0,0,0.04)", transition: "all 0.15s" }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = theme.teal; e.currentTarget.style.boxShadow = "0 4px 16px rgba(14,159,126,0.12)"; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = theme.border; e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.04)"; }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                    <div style={{ width: 44, height: 44, borderRadius: "50%", background: theme.tealPale, display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <span style={{ color: theme.teal, fontSize: 18, fontWeight: 600 }}>{client.name.charAt(0)}</span>
                    </div>
                    <div>
                      <div style={{ fontSize: 18, color: theme.textPrimary, fontWeight: 500, marginBottom: 4 }}>{client.name}</div>
                      <div style={{ fontSize: 14, color: theme.textSecondary }}>{client.presenting_concern || "No concern listed"}</div>
                      {client.date_of_birth && <div style={{ fontSize: 13, color: theme.textMuted, marginTop: 2 }}>DOB: {client.date_of_birth}</div>}
                    </div>
                  </div>
                  <div style={{ color: theme.teal, fontSize: 14, fontWeight: 500 }}>View Notes →</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* NOTES VIEW */}
        {view === "notes" && selectedClient && (
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 32 }}>
              <button onClick={() => { setView("clients"); setExpandedNote(null); }}
                style={{ background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: 8, color: theme.textSecondary, padding: "10px 18px", fontSize: 14, fontFamily: "Georgia, serif", cursor: "pointer" }}>
                ← Clients
              </button>
              <div>
                <h1 style={{ fontSize: 30, fontWeight: 400, color: theme.textPrimary, margin: "0 0 4px" }}>{selectedClient.name}</h1>
                <p style={{ color: theme.textSecondary, fontSize: 15, margin: 0 }}>{selectedClient.presenting_concern}</p>
              </div>
            </div>

            {expandedNote ? (
              <div>
                <button onClick={() => setExpandedNote(null)}
                  style={{ background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: 8, color: theme.textSecondary, padding: "10px 18px", fontSize: 14, fontFamily: "Georgia, serif", cursor: "pointer", marginBottom: 24 }}>
                  ← Back to Notes
                </button>
                <div style={{ background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "32px", boxShadow: "0 2px 8px rgba(0,0,0,0.04)" }}>
                  <div style={{ fontSize: 13, color: theme.textMuted, marginBottom: 20, letterSpacing: 1 }}>
                    {new Date(expandedNote.created_at).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
                  </div>
<NoteDisplay text={expandedNote.soap_note} />
                </div>
                <button onClick={() => { const el = document.createElement("textarea");
  el.value = expandedNote.soap_note;
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
  alert("Note copied!");
}}
                  style={{ marginTop: 16, background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: 8, color: theme.textSecondary, padding: "10px 20px", fontSize: 14, fontFamily: "Georgia, serif", cursor: "pointer" }}>
                  Copy to Clipboard
                </button>
              </div>
            ) : (
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 32 }}>

                {/* Generate Note */}
                <div>
                  <div style={{ background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "28px", boxShadow: "0 2px 8px rgba(0,0,0,0.04)" }}>
                    <h3 style={{ fontSize: 18, color: theme.textPrimary, fontWeight: 500, margin: "0 0 20px" }}>New Session Note</h3>
                    <label style={{ fontSize: 12, letterSpacing: 2, color: theme.teal, textTransform: "uppercase", display: "block", marginBottom: 10, fontWeight: 600 }}>Session Summary</label>
                    <textarea value={summary} onChange={e => setSummary(e.target.value)}
                      placeholder="Describe what happened in the session — presenting concerns, interventions used, client response, homework assigned..."
                      rows={7}
                      style={{ width: "100%", background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 8, color: theme.textPrimary, fontSize: 15, padding: "14px 16px", fontFamily: "Georgia, serif", resize: "vertical", outline: "none", boxSizing: "border-box", lineHeight: 1.7, marginBottom: 16 }} />
                    <button onClick={generateNote} disabled={loading || !summary.trim()}
                      style={{ width: "100%", background: loading || !summary.trim() ? theme.border : theme.teal, color: loading || !summary.trim() ? theme.textMuted : theme.white, border: "none", borderRadius: 8, padding: "14px", fontSize: 16, fontWeight: 600, fontFamily: "Georgia, serif", cursor: loading || !summary.trim() ? "not-allowed" : "pointer", boxShadow: loading || !summary.trim() ? "none" : "0 2px 8px rgba(14,159,126,0.3)", transition: "all 0.2s" }}>
                      {loading ? (
  <span style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ animation: "spin 1s linear infinite" }}>
      <circle cx="12" cy="12" r="10" stroke="rgba(255,255,255,0.3)" strokeWidth="3" />
      <path d="M12 2a10 10 0 0 1 10 10" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
    </svg>
    Generating note...
  </span>
) : "Generate SOAP Note"}
                    </button>
                  </div>

                  {note && (
<div style={{ marginTop: 20, background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "24px" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
                        <label style={{ fontSize: 12, letterSpacing: 2, color: theme.teal, textTransform: "uppercase", fontWeight: 600 }}>Generated Note</label>
                        <button onClick={() => { const el = document.createElement("textarea");
  el.value = note;
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
  alert("Note copied!");
}}
                          style={{ background: theme.white, border: `1px solid ${theme.teal}44`, borderRadius: 6, color: theme.teal, padding: "6px 14px", fontSize: 13, fontFamily: "Georgia, serif", cursor: "pointer" }}>
                          Copy
                        </button>
                      </div>
<NoteDisplay text={note} />                    </div>
                  )}
                </div>

                {/* Past Notes */}
                <div>
                  <h3 style={{ fontSize: 18, color: theme.textPrimary, fontWeight: 500, margin: "0 0 16px" }}>Past Notes ({notes.length})</h3>
                  {notes.length === 0 && (
                    <div style={{ background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "40px", textAlign: "center", color: theme.textMuted, fontSize: 15 }}>
                      No notes yet for this client.
                    </div>
                  )}
                  <div style={{ display: "grid", gap: 12 }}>
                    {notes.map(n => (
                      <div key={n.id} onClick={() => setExpandedNote(n)}
                        style={{ background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "20px 24px", cursor: "pointer", boxShadow: "0 2px 8px rgba(0,0,0,0.04)", transition: "all 0.15s" }}
                        onMouseEnter={e => { e.currentTarget.style.borderColor = theme.teal; e.currentTarget.style.boxShadow = "0 4px 16px rgba(14,159,126,0.12)"; }}
                        onMouseLeave={e => { e.currentTarget.style.borderColor = theme.border; e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.04)"; }}>
                        <div style={{ fontSize: 12, color: theme.teal, marginBottom: 8, letterSpacing: 1, fontWeight: 600 }}>
                          {new Date(n.created_at).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
                        </div>
                        <div style={{ fontSize: 14, color: theme.textSecondary, lineHeight: 1.7 }}>{n.soap_note.slice(0, 160)}...</div>
                        <div style={{ fontSize: 13, color: theme.teal, marginTop: 10, fontWeight: 500 }}>Read full note →</div>
                      </div>
                    ))}
                  </div>
                </div>

              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
